export type RovoNavigationClickedProps = {
	source: string;
	queryHash: string;
	queryLength: number;
	searchSessionId?: string;
	isHello?: boolean;
	referrer?: string;
	experiment?: string;
	// QS-10204 — the user's `rovo_jira_navigation_to_gnin` experiment cohort
	// (`control` | `work-item-icon` | `header-link`), used to segment navigation
	// clicks by cohort. Remove this attribute when cleaning up the experiment.
	gninNavigationCohort?: string;
	commonAttributes?: Record<string, any>;
};

export const onRovoNavigationClicked: ({
	source,
	experiment,
	gninNavigationCohort,
	commonAttributes,
	queryHash,
	queryLength,
	searchSessionId,
	isHello,
	referrer,
}: RovoNavigationClickedProps) => {
	source: string;
	eventType: 'ui';
	action: string;
	actionSubject: string;
	name: string;
	attributes: {
		commonAttributes: Record<string, any> | undefined;
		queryHash: string;
		queryLength: number;
		searchSessionId: string | undefined;
		isHello: boolean | undefined;
		referrer: string | undefined;
		additionalAttributes: {
			experiment: string | undefined;
			gninNavigationCohort: string | undefined;
		};
	};
} = ({
	source,
	experiment,
	gninNavigationCohort,
	commonAttributes,
	queryHash,
	queryLength,
	searchSessionId,
	isHello,
	referrer,
}: RovoNavigationClickedProps) => ({
	source,
	eventType: 'ui' as const,
	action: 'clicked',
	actionSubject: 'rovoNavigation',
	name: 'rovoNavigation',
	attributes: {
		commonAttributes,
		queryHash,
		queryLength,
		searchSessionId,
		isHello,
		referrer,
		additionalAttributes: {
			experiment,
			gninNavigationCohort,
		},
	},
});
